import * as Highcharts from 'highcharts';
import { BOTTOM_BORDER_Z_INDEX } from './plot-decorations.constants';
import { DecoratedChart, PlotDecorations } from './plot-decorations.types';

/** Plot-area bottom border and tinted bands, for a chart `render` callback. */
export function drawPlotDecorations(
  chart: DecoratedChart,
  { bottomBorderColor, bands }: PlotDecorations
): void {
  const plotBox = chart.plotBox;
  if (!plotBox) return;

  const plotBottom = plotBox.y + plotBox.height;
  const plotRight = plotBox.x + plotBox.width;
  const borderPath = [
    'M',
    plotBox.x,
    plotBottom,
    'L',
    plotRight,
    plotBottom,
  ] as unknown as Highcharts.SVGPathArray;

  if (!chart.bottomBorderLine) {
    chart.bottomBorderLine = chart.renderer
      .path(borderPath)
      .attr({
        'stroke-width': 1,
        stroke: bottomBorderColor,
        zIndex: BOTTOM_BORDER_Z_INDEX,
      })
      .add();
  } else {
    chart.bottomBorderLine.attr({ d: borderPath, stroke: bottomBorderColor });
  }

  (chart.chartBackgroundRects ?? []).forEach((rect) => rect.destroy());
  const rects: Highcharts.SVGElement[] = [];
  chart.chartBackgroundRects = rects;

  const axis = chart.xAxis[0];
  bands.forEach(({ from, to, fill, zIndex }) => {
    const x1 = Math.max(axis.toPixels(from, false), plotBox.x);
    const x2 = Math.min(axis.toPixels(to, false), plotRight);
    if (x2 <= x1) return;

    rects.push(
      chart.renderer
        .rect(x1, plotBox.y, x2 - x1, plotBox.height)
        .attr({ fill, zIndex })
        .add()
    );
  });
}
